import type { RouteObject } from "react-router";
import { Outlet } from "react-router";

import { Layout as AppLayout } from "@/layouts/app";
import { Layout as MarketingLayout } from "@/layouts/marketing";
import { getCustomDomainHostname } from "@/lib/custom-domain";

import HomePage from "@/pages/Index";
import NotFound from "@/pages/not-found";
import PublicSite from "@/pages/PublicSite";

import { appRoutes } from "./app";
import { siteRoutes } from "./site";

// A verified custom domain means every path on this origin belongs to one
// unit's public site — it should never render the site-builder marketing
// homepage, sign-up flow, or the operator app's own nav/chrome, unlike the
// default host's /site/:slug path below.
const customDomainRoutes: RouteObject[] = [
  {
    path: "*",
    element: <PublicSite />,
  },
];

const defaultHostRoutes: RouteObject[] = [
  {
    element: (
      <MarketingLayout>
        <Outlet />
      </MarketingLayout>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    element: (
      <AppLayout>
        <Outlet />
      </AppLayout>
    ),
    children: [...appRoutes],
  },
  // PublicSite builds its own complete header/nav/footer chrome (in the
  // unit's own theme) — it must not be nested inside either operator layout
  // above, or visitors would see duplicate nav/footer bars.
  ...siteRoutes,
];

export const routes: RouteObject[] = getCustomDomainHostname() ? customDomainRoutes : defaultHostRoutes;
